import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import BlogForm from "./component";
import Loader from "../../../../components/Loader";
import editBlogPost from "../../../../modules/blog/editBlogPost";

function BlogFormContainer(props) {
  const { id } = props.match.params;
  if (props.loading) {
    return <Loader />;
  }
  return (
    <BlogForm
      title={props.title}
      author={props.author}
      coverImage={props.coverImage}
      bodyHtml={props.bodyHtml}
      highlightHtml={props.highlightHtml}
      updatingPost={props.updatingPost}
      errorUpdating={props.errorUpdating}
      saveBlogPost={data => props.editBlogPost(id, data)}
    />
  );
}

function mapStateToProps(state) {
  return {
    title: state.blogPosts.currentPost.title,
    author: state.blogPosts.currentPost.author,
    coverImage: state.blogPosts.currentPost.coverImage,
    bodyHtml: state.blogPosts.currentPost.bodyHtml,
    highlightHtml: state.blogPosts.currentPost.highlightHtml,
    loading: state.blogPosts.loading,
    updatingPost: state.blogPosts.updatingPost,
    errorUpdating: state.blogPosts.errorUpdating
  };
}

const mapActionToProps = {
  editBlogPost
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(BlogFormContainer)
);



// WEBPACK FOOTER //
// ./src/pages/Admin/BlogDocument/BlogForm/container.js